module.exports = __webpack_public_path__ + "img/536-42dfb3.png";